import { render, staticRenderFns } from "./LogListingItemChangeRequest.vue?vue&type=template&id=f82c74a4&scoped=true&"
import script from "./LogListingItemChangeRequest.vue?vue&type=script&lang=js&"
export * from "./LogListingItemChangeRequest.vue?vue&type=script&lang=js&"
import style0 from "./LogListingItemChangeRequest.vue?vue&type=style&index=0&id=f82c74a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82c74a4",
  null
  
)

export default component.exports